"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentOpeningHours = void 0;
const libs_utils_1 = require("@hotelplan/libs.utils");
function getCurrentOpeningHours(openingHours, currentDate = new Date(), language, timeZone) {
    const isoDay = timeZone
        ? parseInt((0, libs_utils_1.formatDateInTimeZone)(currentDate, 'i', language, timeZone))
        : (0, libs_utils_1.getISODay)(currentDate);
    return openingHours[isoDay - 1];
}
exports.getCurrentOpeningHours = getCurrentOpeningHours;
//# sourceMappingURL=getCurrentOpeningHours.js.map